import { Injectable } from '@angular/core';
import { SessionService } from '@/common/auth/auth-session.service';
import {environment} from "@env/environment";

@Injectable({
	providedIn: 'root'
})
export class DevToolsService {
	constructor(
		private session: SessionService,
	) {}

	/**
	 * open devtool url with auth token as a query param
	 */
	openTool(tool: string): void {
		window.open(`${environment.apiUrl}/${tool}?token=${this.session.getAccessToken()}`, '_blank');
	}
}
